import axios from "axios";

const API_KEY = "23362e61e8bb39816dcb5c5ca676d07d";
const USER_ID = "263351";

export async function getAppodealStats({ date_from="", date_to="" }) {
  try {
    // Step 1: Create report task
    const createRes = await axios.get(
      "https://api-services.appodeal.com/api/v2/stats_api",
      {
        params: {
          api_key: API_KEY,
          user_id: USER_ID,
          date_from: date_from,
          date_to: date_to,
          "detalisation[]": ["date", "app"],
          "app[]": "0c102fa0276f9928de2d12b07aef646a3b925a6b23b305e4",
        },
      },
    );

    console.log("Create Task:", createRes.data);

    const taskId = createRes.data.task_id;

    if (!taskId) {
      throw new Error("Task ID not found");
    }

    // Step 2: Wait a little
    await new Promise((resolve) => setTimeout(resolve, 3000));

    // Step 3: Check status
    const statusRes = await axios.get(
      "https://api-services.appodeal.com/api/v2/check_status",
      {
        params: {
          api_key: API_KEY,
          user_id: USER_ID,
          task_id: taskId,
        },
      },
    );

    console.log("Status:", statusRes.data);

    // If ready
    if (statusRes.data.status === "done") {
      // Step 4: Get final result
      const resultRes = await axios.get(
        "https://api-services.appodeal.com/api/v2/output_result",
        {
          params: {
            api_key: API_KEY,
            user_id: USER_ID,
            task_id: taskId,
          },
        },
      );

      console.log("Final Data:", resultRes.data);

      return resultRes.data;
    }
  } catch (error) {
    console.error("Appodeal API Error:", error);
  }
}
